module.exports = new __parcel__URL__("sweatshirt_blue.3774e1f6.jpg").toString();